<template>
  <div>
    <el-container>

      <el-main v-loading="loading">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont">&#xe60b;</i>&nbsp;返回首页</el-breadcrumb-item>
              <el-breadcrumb-item>
                智能报告
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                A股
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <template v-if="tabsName === 'stock'">
                  个股分析
                </template>
                <template v-if="tabsName === 'finance'">
                  财务分析
                </template>
                <template v-if="tabsName === 'compare'">
                  投资组合
                </template>
                <template v-if="tabsName === 'concept'">
                  概念分析
                </template>

                <template v-if="tabsName === 'perception'">
                  市场感知
                </template>
                <template v-if="tabsName === 'year'">
                  年报解析
                </template>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <br> <br>
          <el-col :span="22" :offset="1" class="whiteContainer">
            <template>
              <el-tabs v-model="tabsName">
                <el-tab-pane label="个股分析" name="stock">
                  <stock v-if="tabsName === 'stock'" />
                </el-tab-pane>
                <el-tab-pane label="财务分析" name="finance">
                  <finance v-if="tabsName === 'finance'" />
                </el-tab-pane>
                <el-tab-pane label="投资组合" name="compare">
                  <compare v-if="tabsName === 'compare'" />
                </el-tab-pane>
                <el-tab-pane label="概念分析" name="concept">
                  <concept v-if="tabsName === 'concept'" />
                </el-tab-pane>

                <el-tab-pane label="市场感知" name="perception">
                  <perception />
                </el-tab-pane>
                <el-tab-pane label="年报解析" name="year">
                  <year />
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-col>
        </el-row>
      </el-main>

    </el-container>

  </div>
</template>

<script>

import finance from '../components/index/finance'
import stock from '../components/index/stock'
import concept from '../components/index/concept'
import compare from '../components/index/compare'
import perception from '../components/index/perception'
import year from '../components/index/year.vue'
export default {
  name: 'ele',
  data: function () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,

      tabsName: 'stock',

      conceptDialogVisible: false,
      conceptSearchLogs: [],
      curReport: {}

    }
  },
  filters: {

  },
  components: {
    finance, stock, concept, compare, perception, year
  },
  computed: {

  },
  watch: {
    tabsName: function () {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '生成报告页签', this.tabsName])
    }
  },

  methods: {

  },

  mounted () {

  }
}
</script>
<style lang="less" scoped>
.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}

.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}

.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/index.vue